<template>
    <div class="wasser">
        <p>
            entwässertes Kupfer(II)sulfat (weiß) färbt sich hellblau.
            <br />
            CuSO<sub>4</sub> + H<sub>2</sub>O → CuSO<sub>4</sub> * 5
            H<sub>2</sub>O
            <br />
            blaues Kobaltchloridpapier färbt sich rot
        </p>
    </div>
</template>

<script>
export default {
    name: 'wasser',
};
</script>
